export enum AuditField {
    TRANSACTION_ID = 'transactionId',
    CREATED_AT = 'createdAt',
    CREATED_BY = 'createdBy',
    SOURCE = 'source',
    SOURCE_ID = 'sourceId',
    OPERATION = 'operation',
    CHANGES = 'changes',
}
